import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import * as moment from 'moment';
import { HostListener } from '@angular/core';
import { element } from 'protractor';
declare var $: any;
@Component({
  selector: 'app-calmois',
  templateUrl: './calmois.component.html',
  styleUrls: ['./calmois.component.css'],
})
export class CalmoisComponent implements OnInit, AfterViewInit {
  // dateM: Date;
  dateMois: Date;
  @Input() listeCal = [];
  /******* */
  /********* */
  nbdeb = 0;
  nbfin = 0;
  monthsTab = Array(
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre'
  );
  // showMois;
  // cssWeek;
  constructor() {}
  selectedDays = [];
  keyCtrlActive: boolean = false;
  canSelectOrDeselectDay: boolean = false;
  beginSelectOrDeselect: boolean = true;
  ngOnInit() {
    this.listeCal.forEach((cal) => {
      cal['restColonne'] = [];
      cal['cssWeek'] = this.getParamWeek(cal.listParamsDay);
      // this.cssWeek = this.getParamWeek(cal.listParamsDay);
      cal['dateMois'] = new Date(cal.annee, cal.mois, 1);
      // this.showMois = this.monthsTab[cal["dateMois"].getMonth()] + " "+ cal["dateMois"].getFullYear();
      cal['showMois'] =
        this.monthsTab[cal['dateMois'].getMonth()] +
        ' ' +
        cal['dateMois'].getFullYear();
      var aa = cal['dateMois'];
      const startOfMonth = moment(aa).startOf('month').toDate();
      // this.dateM = moment(startOfMonth).startOf('isoWeek').toDate();
      cal['dateM'] = moment(startOfMonth).startOf('isoWeek').toDate();
      cal['dateM'].setDate(cal['dateM'].getDate() - 1);
      for (var k = 0; k < 8; k++) {
        var jours = [];
        for (var j = 0; j < 7; j++) {
          var nb = this.addDate(k, j, cal['dateMois'], cal['dateM']);
          var classe;
          var week;
          if (nb != null) {
            cal['dateMois'].setDate(nb);
            week = this.getWeekNumber(cal['dateMois']);
          }
          var paramsDay = this.getParamsDay(
            cal['dateMois'],
            nb,
            cal.listParamsDay
          );
          var date;
          if (this.getStrDate(nb, cal['dateMois'])) {
            var tabDate = this.getStrDate(nb, cal['dateMois']).split('/');
            date = new Date(tabDate[2] + '-' + tabDate[1] + '-' + tabDate[0]);
          }

          jours.push({
            nb: nb,
            statut: false,
            type: 0,
            class: classe,
            actif: paramsDay.actif, // selectionnable ou non
            AMPM: paramsDay.AMPM, // 1 journer total, 2 am, 3 pm
            bgColor: paramsDay.bgColor, // couleur de fon du jour
            textColor: paramsDay.textColor, // couleur du text
            week: week,
            tooltip: paramsDay.tooltip,
            date: date ? new Date(date) : null,
            strDate: this.getStrDate(nb, cal['dateMois']),
          });
        }
        if (jours[0].nb == null && jours[jours.length - 1].nb == null) break;
        cal.val.push(jours);
        if (jours[jours.length - 1].nb == null) break;
      }
      for (var i = 0; i < 6 - cal.val.length; i++) {
        cal['restColonne'].push('');
      }
    });
  }
  ngAfterViewInit() {
    this.initFunctionSelection();
  }
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode == 17) {
      this.keyCtrlActive = true;
    }
  }
  @HostListener('window:keyup', ['$event'])
  keyEvenst(event: KeyboardEvent) {
    if (event.keyCode == 17) {
      this.keyCtrlActive = false;
    }
  }
  getDate(nb: number, dateMois) {
    if (nb != null) return dateMois;
    else return null;
  }
  initFunctionSelection() {
    $(() => {
      $('#clmois').selectable({
        filter: 'td.selectable',
        stop: (e, ui) => {
          this.setSelectedDays();
        },
        unselected: (e, ui) => {},
        selected: (e, ui) => {
          //console.log(ui.selected)
        },
      });
    });
  }
  setSelectedDays() {
    this.selectedDays = [];

    var listeselectedDays = $('.ui-selected')
      .map(function () {
        return this.id;
      })
      .get();
    listeselectedDays.forEach((jour) => {
      this.listeCal.forEach((cal) => {
        cal.val.forEach((myCal) => {
          this.selectedDays = this.selectedDays.concat(
            myCal.filter((c) => {
              return c.strDate == jour;
            })
          );
        });
      });
    });
  }
  getStrDate(nb: number, dateMois: Date) {
    if (nb != null) return this.setFormatDate(dateMois);
    else return null;
  }
  getParamsDay(dateMois: Date, nb: number, listParamsDay) {
    const paramsDay = this.initParamsDay('00', dateMois);
    var paramsDay2 = paramsDay;
    if (listParamsDay != null) {
      var dateMoisStr =
        dateMois.getDate() +
        '/' +
        (dateMois.getMonth() + 1) +
        '/' +
        dateMois.getFullYear();
      //pour les case vide
      if (nb == null) {
        var tab = dateMoisStr.split('/');
        dateMoisStr = '00/' + tab[1] + '/' + tab[2];
      }
      paramsDay2 = listParamsDay.find((element) => {
        return element.day == dateMoisStr;
      });
      if (paramsDay2 == undefined) {
        console.log(
          "element '" + dateMoisStr + "' qui menque dans la liste listParamsDay"
        );
        return paramsDay;
      } else return paramsDay2;
    } else return paramsDay;
  }
  mouseupEvent(event, value) {
    // this.nbdeb =0;
  }
  mousedownEvent(event, value) {
    if (this.beginSelectOrDeselect) this.nbdeb = parseInt(value.nb.toString());
    this.beginSelectOrDeselect = false;
    if (value.statut == true) this.deleteSelection(value);
    else this.setSelection(value);

    // if(this.nbdeb == 0)
    // {
    //   this.nbdeb = value.nb;
    //   if(value.statut == true)
    //     this.deleteSelection(value);
    //   else
    //     this.setSelection(value);

    // }
  }
  setSelection(value) {
    if (value.nb > 0 && value.actif) {
      value.statut = true;
      var selectedDays = this.selectedDays.find((selectedDay) => {
        return selectedDay.strDate == value.strDate;
      });
      if (selectedDays == undefined) this.selectedDays.push(value);
    }
  }

  deleteSelection(value) {
    if (value.nb > 0 && value.actif) {
      value.statut = false;
      this.selectedDays = this.selectedDays.filter((selectedDay) => {
        return selectedDay.strDate != value.strDate;
      });
    }
  }

  // mouseEnterEvent(event,value)
  // {
  //   if(value.nb > 0  && this.canSelectOrDeselectDay)
  //   {
  //     if(this.beginSelectOrDeselect)
  //       this.nbdeb = parseInt(value.nb.toString())
  //     this.beginSelectOrDeselect = false;
  //     {
  //       if(value.statut == false)
  //       {
  //         if(!this.keyCtrlActive)
  //         {
  //           this.nbfin = value.nb;
  //           this.cals.forEach(e =>
  //           {
  //             e.forEach(jj =>
  //             {
  //               if ((jj.nb >= this.nbdeb && jj.nb <= this.nbfin ) || (jj.nb >= this.nbfin && jj.nb <= this.nbdeb ) )
  //               {
  //                 this.setSelection(jj);
  //               }
  //             });
  //           });
  //         }
  //         else
  //         {
  //           this.setSelection(value);
  //         }
  //       }
  //       else
  //       {
  //         if(!this.keyCtrlActive)
  //         {
  //           this.nbfin = value.nb;
  //           this.cals.forEach(e =>
  //           {
  //             e.forEach(jj =>
  //             {
  //               if ( (jj.nb >= this.nbdeb && jj.nb <= this.nbfin ) || (jj.nb >= this.nbfin && jj.nb <= this.nbdeb ) )
  //               {
  //                 this.deleteSelection(jj);
  //               }
  //             });
  //           });
  //         }
  //         else
  //         {
  //           this.deleteSelection(value);
  //         }
  //       }
  //     }
  //   }
  // }
  selectionWheneMouseEnter() {}
  mouseLeaveEvent() {
    //this.nbdeb =0;
  }

  keydownEvent(event) {}

  createRange(number) {
    var items: number[] = [];
    for (var i = 1; i <= number; i++) {
      items.push(i);
    }
    return items;
  }

  createRange1(number) {
    var items: number[] = [];
    for (var i = 1; i <= number; i++) {
      items.push(i);
    }
    return items;
  }

  addDate(ii, jj, kk, bb) {
    let df = new Date(bb);
    df.setDate(df.getDate() + ii * 7 + (jj + 1));

    //  console.log(df);
    if (df.getMonth() == kk.getMonth()) return df.getDate();
    else return null;
  }

  onContextMenu(event: MouseEvent, value) {
    this.setSelection(value);
  }
  //gh = [];

  getWeekNumber(uneDate) {
    var d = new Date(uneDate);
    var DoW = d.getDay();
    d.setDate(d.getDate() - ((DoW + 6) % 7) + 3); // Nearest Thu
    var ms = d.valueOf(); // GMT
    d.setMonth(0);
    d.setDate(4); // Thu in Week 1
    return Math.round((ms - d.valueOf()) / (7 * 864e5)) + 1;
  }
  setFormatDate(date: Date) {
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });
  }
  initParamsDay(nb: String, date: Date) {
    return {
      day: nb + '/' + (date.getMonth() + 1) + '/' + date.getFullYear(),
      actif: true, //selectionnable ou non
      AMPM: 1, //1 journer total, 2 am, 3 pm
      bgColor: {}, // couleur de fon du jour
      textColor: {}, // coule de text;
      tooltip: '',
    };
  }
  getParamWeek(listParamsDay) {
    var date = new Date();
    var paramsDay2 = listParamsDay.find((element) => {
      return element.day.indexOf('week') > -1;
    });
    if (paramsDay2 == undefined || paramsDay2 == null)
      return this.initParamsDay('00', date);
    else return paramsDay2;
  }
}
